import { SITE_URL } from '../constants/seo';

export const createRoomLink = (roomId: string): string => {
  return `${SITE_URL}/s/${encodeURIComponent(roomId)}`;
};

export const buildRoomSchedulingDescription = (roomId: string): string =>
  `View availability: ${createRoomLink(roomId)}`;
